import type { AddBalancePayload } from 'src/store/shared/balances/types';
import { BalanceCommands } from 'src/store/shared/balances/types';
import { createAppAsyncThunk } from 'src/store/utils/thunks';
import { selectLoanBalancesExtended } from 'src/store/loans/balances/selectors';
import { selectColdWallets as selectLoanColdWallets } from 'src/store/loans/cold-wallets/selectors';
import { selectColdWallets as selectProjectColdWallets } from 'src/store/retainers/cold-wallets/selectors';
import { dexColdWalletApiEndpoints } from '@skynet/data-dex-cold-wallets';
import { createMmWsAction } from '@skynet/data-ws-mm';

const addBalanceWs = createMmWsAction<AddBalancePayload, AddBalancePayload>(
  'balances/addBalanceWs',
  (data) => ({
    command: BalanceCommands.AddBalance,
    ...data,
  }),
);

export const addBalance = createAppAsyncThunk(
  'balances/addBalance',
  (data: AddBalancePayload, { getState, dispatch }) => {
    const state = getState();
    const accounts = selectLoanBalancesExtended(state);
    const account = accounts.find((acc) => acc.accountID === data.accountID);
    const balances = account?.assets ?? [];

    balances.forEach(({ token, volume, volumeUSD }) => {
      const updated = data.balances.find((b) => b.token === token);
      if (!updated) {
        data.balances.push({
          token,
          value: volume,
          usd: volumeUSD,
        });
      }
    });

    return dispatch(addBalanceWs(data));
  },
);

export const createSnapshots = createAppAsyncThunk(
  'balances/createSnapshots',
  async (data: { loanID: number } | { projectID: number }, { dispatch, getState }) => {
    let selectColdWallets;
    if ('loanID' in data && data.loanID) {
      selectColdWallets = selectLoanColdWallets;
      dispatch(createBalancesSnapshot({ loanID: data.loanID }));
    }
    if ('projectID' in data && data.projectID) {
      selectColdWallets = selectProjectColdWallets;
      dispatch(createBalancesSnapshot({ projectID: data.projectID }));
    }
    const state = getState();
    const coldWallets = selectColdWallets?.(state) ?? [];
    const walletIds = coldWallets.map(({ accountID }) => Number(accountID));
    return dispatch(
      dexColdWalletApiEndpoints.createColdWalletSnapshot.initiate({ snapshotDto: { walletIds } }),
    );
  },
);

export const createBalancesSnapshot = createMmWsAction<
  { loanID: number } | { projectID: number },
  { loanID: number } | { projectID: number }
>('balances/createSnapshotWs', (data) => ({
  command: BalanceCommands.AddBalance,
  ...data,
}));
